import { Skeleton } from '@material-ui/lab';
import { useEffect } from 'react';

import { ApplicationStepContainer } from '@/components/modules/Application/components/_shared/components/ApplicationStepContainer';
import { Section } from '@/components/modules/Application/components/_shared/components/Section/Section';
import { SectionTitle } from '@/components/modules/Application/components/_shared/components/Section/SectionTitle';
import { usePaymentMethods } from '@/components/modules/Application/components/PaymentMethod/_shared/hooks/usePaymentMethods';
import { AutoSimulator } from '@/components/modules/Application/components/PaymentMethod/AutoLoan/components/PaymentMethodCard/AutoSimulator';
import { AutoLoanPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/AutoLoan/entities/PaymentMethod/AutoLoanPaymentMethod';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface PaymentMethodSimulatorProps {
  firstRendered: boolean;
}

export const PaymentMethodSimulator = ({ firstRendered }: PaymentMethodSimulatorProps) => {
  const { paymentMethodEntities, setupPaymentMethodEntity } = usePaymentMethods();

  const { customBorderRadius } = useCustomTheme();

  const paymentMethodEntity = paymentMethodEntities?.[0] as AutoLoanPaymentMethod;
  if (!paymentMethodEntity) return null;

  useEffect(() => {
    if (paymentMethodEntity) {
      setupPaymentMethodEntity(paymentMethodEntity);
    }
  }, [paymentMethodEntity]);

  return (
    <ApplicationStepContainer>
      <Section disableAnimation={firstRendered}>
        <SectionTitle title={'PAYMENT_METHOD'} subtitle={'SELECT_CONDITION_FROM_SIMULATOR'} />
        {paymentMethodEntity.isSetup ? (
          <AutoSimulator paymentMethodEntity={paymentMethodEntity} />
        ) : (
          <Skeleton variant="rect" width={'100%'} height={'650px'} style={{ borderRadius: customBorderRadius.paper }} />
        )}
      </Section>
    </ApplicationStepContainer>
  );
};
